import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// _data
// components
//text-transition
import TextTransition, { presets } from "react-text-transition";

// @mui
import { Box, Button, Container, Grid, Typography } from "@mui/material";

//images
import Bg from "assets/images/home-bg.png";
// import AppImg from "assets/images/home-app.png";

// ----------------------------------------------------------------------

const TEXTS = ["문화생활", "페스티벌"];

export default function HomePage() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const { search: Search } = useLocation();
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const intervalId = setInterval(() => setIndex((index) => index + 1), 2000);
    console.log("Search", Search);
    if (Search) {
      const { pathname, search } = Search.slice(1)
        .split("&")
        .reduce((obj, item) => {
          const [key, value] = item.split("=");
          return {
            ...obj,
            [key]: key === "search" ? decodeURIComponent(value) : value,
          };
        }, {});
      window.history.pushState({}, null, "/");
      setUrl(pathname + search);
    } else {
      setUrl("/");
    }
    return () => clearTimeout(intervalId);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        minHeight: "100vh",
        bgcolor: "black",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `center/cover no-repeat url(${Bg})`,
      }}
    >
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={8}>
            {/* text-transition */}
            <Typography color="white" variant="h3" sx={{ fontWeight: "light" }}>
              <Box
                component="span"
                sx={{
                  color: "primary.main",
                  fontWeight: "bold",
                  display: "flex",
                }}
              >
                <Box
                  component="span"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    display: "flex",
                  }}
                >
                  &#91;
                </Box>
                <TextTransition springConfig={presets.slow}>
                  {TEXTS[index % TEXTS.length]}
                </TextTransition>
                <Box
                  component="span"
                  sx={{
                    color: "primary.main",
                    fontWeight: "bold",
                    display: "flex",
                  }}
                >
                  &#93;
                </Box>
                &nbsp;
                <Box
                  component="span"
                  sx={{ color: "white", fontWeight: "light" }}
                >
                  을 빛나게 할
                </Box>
                <br />
              </Box>
              <strong>완벽한 몰입의 경험</strong>을 설계합니다.
            </Typography>
            {/* /text */}
            <Button
              variant="outlined"
              sx={{
                mt: 2,
                borderColor: "white",
                borderRadius: 10,
                py: 1,
                px: 2,
                "&:hover": {
                  borderColor: "white",
                },
              }}
              onClick={() => navigate("/about")}
            >
              <Typography variant="body" color={"white"}>
                퀸즈소개 바로가기 →
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Box
              sx={{
                height: 0,
                paddingBottom: "200%",
                boxSizing: "border-box",
                position: "relative",
                ".MuiBox-root": {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  iframe: {
                    width: "100%",
                    height: "100%",
                    maxHeight: "80vh",
                    flexGrow: 1,
                    border: 0,
                    borderRadius: "1rem",
                    display: "block",
                  },
                },
              }}
            >
              <Box>
                <iframe src={`https://queenssmile.co.kr${url || "/"}`}></iframe>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
